module.exports = __webpack_public_path__ + "img/hat_male_beanie_mask.abd40aaa.png";